import { useState, useEffect } from "react";

import { API_URL, getValFromLS, setValToLS, scroll } from "../../helpers";
import useFetch from "../../useFetch";

import Alert from "../../components/Alert";

import S from "./styled";

const Receipt = ({ handleStatus }) => {
	const [url, setUrl] = useState(null);
	const [details, setDetails] = useState({});
	const [alert] = useState({});

	const { loading, data } = useFetch(url);

	useEffect(() => {
		const newUrl = new URL(`${API_URL}/`);
		const params = {
			f: "donateReceiptInit",
			id: getValFromLS("receipt", true) ? getValFromLS("receipt", true) : "",
			x: crypto.randomUUID(),
		};
		newUrl.search = new URLSearchParams(params);
		setUrl(newUrl);

		// eslint-disable-next-line
	}, []);

	useEffect(() => {
		if (data && data.resp === 1) {
			scroll();
			setDetails({ ...data });
			setValToLS("receipt", null, true);
		} else if (data && data.resp === 0) {
			handleStatus(2);
		}

		// eslint-disable-next-line
	}, [data]);

	return (
		<>
			{loading || alert.type ? (
				<Alert
					data={
						loading
							? {
									type: "working",
									text: "",
							  }
							: alert
					}
				/>
			) : (
				<S.Container>
					<Alert
						data={{
							type: "success",
							text: "Your donation has been submitted, thank you!",
						}}
					/>

					<S.Hdg>
						<h4>Donation Receipt</h4>

						<p>
							A copy of this order has been emailed to{" "}
							<strong>{details.email}</strong>, please remember to check your
							spam folder if not received in a few minutes.
						</p>
					</S.Hdg>

					<S.Table1>
						<thead>
							<tr>
								<th>Name</th>
								<th>Order ID</th>
								<th>Date</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td className="center">{details.name}</td>
								<td className="center">{details.id}</td>
								<td className="center">{details.date}</td>
							</tr>
						</tbody>
					</S.Table1>

					<S.Note>
						<p>
							Thank you so much for your most generous donation to the Lois Pope
							LIFE Foundation.
						</p>

						{/*	removed 4/24/26 per Cara 
									disabled veterans through the “Pups4Patriots”
							program at American Humane, 
							*/}

						<p>
							Funds raised benefit South Florida youth through the Palm Beach
							County Food Bank’s “Lois’ Food4Kids” endeavor and Lois’
							Vision4Kids program in partnership with Bascom Palmer Eye
							Institute.
						</p>

						<p>
							You will receive a separate personalized letter from Leaders In
							Furthering Education, Inc. (LIFE) regarding tax benefits related
							to your contribution.
						</p>

						<p>
							Sincerely,
							<br />
							<br />
							Lois Pope
						</p>
					</S.Note>

					<S.Table2>
						<thead>
							<tr>
								<th className="qty">Qty</th>
								<th className="left">Item</th>
								<th>Amount</th>
							</tr>
						</thead>
						<tbody>
							{details.items.map((item) => {
								return (
									<tr key={item.id}>
										<td className="qty center">
											<span>{item.qty}</span>
										</td>
										<td>
											<div>
												<span>{item.name}</span>
											</div>
										</td>
										<td className="right">{item.amount}</td>
									</tr>
								);
							})}
						</tbody>
						<tfoot>
							<tr>
								<th colSpan="2" className="right">
									TOTAL
								</th>
								<th className="right">{details.total}</th>
							</tr>
							<tr>
								<th colSpan="2" className="right">
									{details.payment.description}
								</th>
								<th className="right">{details.payment.amount}</th>
							</tr>
						</tfoot>
					</S.Table2>
				</S.Container>
			)}
		</>
	);
};

export default Receipt;
